export default {
  name: "CardPanel",
  props: ["title"]
};